export async function resizeLogo(file: File): Promise<File> {
    if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) {
        throw new Error('Choose a PNG, JPG, or WebP under 2 MB.')
    }

    let image: ImageBitmap
    try {
        image = await createImageBitmap(file)
    } catch {
        throw new Error('Could not read logo. Choose a valid PNG, JPG, or WebP image.')
    }

    try {
        if (Math.max(image.width, image.height) <= 1024) return file

        const scale = 1024 / Math.max(image.width, image.height)
        const canvas = document.createElement('canvas')
        canvas.width = Math.max(1, Math.round(image.width * scale))
        canvas.height = Math.max(1, Math.round(image.height * scale))
        const context = canvas.getContext('2d')
        if (!context) throw new Error('Could not upload logo')
        context.drawImage(image, 0, 0, canvas.width, canvas.height)

        const blob = await new Promise<Blob>((resolve, reject) => {
            canvas.toBlob(
                (result) => (result ? resolve(result) : reject(new Error('Could not upload logo'))),
                file.type,
                0.9
            )
        })
        if (blob.size > 2 * 1024 * 1024) throw new Error('Choose a PNG, JPG, or WebP under 2 MB.')
        const extension = blob.type === 'image/jpeg' ? 'jpg' : blob.type === 'image/webp' ? 'webp' : 'png'
        return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.' + extension, { type: blob.type })
    } finally {
        image.close()
    }
}
